import { render, staticRenderFns } from "./allform.vue?vue&type=template&id=fcd83c64&"
import script from "./allform.vue?vue&type=script&lang=js&"
export * from "./allform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports